angular.module('unergie.main')
.directive('userInfoContractElecInformation', ($filter, $location, AddrService, DataAccess, ApiUser, AlertManager, BoFeaturesService, AuthService, ModalService,
    PrmUtilsService, AdminComments, ApiCons, MetaWatcher, OfferService, ReferencesService, XmlParser, ErrorCatcher, TogglerUtils) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractElecInformation.html',
        link($scope) {
            const feats = BoFeaturesService.getModuleFeatures('contracts')
            const showDCPowerMax = BoFeaturesService.isFeatureOn('showDCPowerMax')

            $scope.pot = BoFeaturesService.isFeatureOn('pot')
            $scope.canAddPromoOnContract = BoFeaturesService.isFeatureOn('canAddPromoOnContract')
            $scope.canModifyConsents = BoFeaturesService.isFeatureOn('canModifyConsents')
            $scope.trainingMode = BoFeaturesService.isFeatureOn('trainingMode')
            $scope.displayField = BoFeaturesService.fieldTester('contracts')
            $scope.providerLabel = BoFeaturesService.get('providerLabel')
            $scope.canChangeOffer = BoFeaturesService.isFeatureOn('canChangeOffer')
            $scope.opportunityButton = BoFeaturesService.isFeatureOn('opportunityButton')
            $scope.showBillingModality = BoFeaturesService.isFeatureOn('showBillingModality')
            $scope.readingsLink = AuthService.getSubMenus().includes('readings')
            $scope.togglerUtils = TogglerUtils
            $scope.isCFeatureOn = (feature) => feats[feature]

            $scope.isDepositNeeded = false
            $scope.isRedFlag = false
            $scope.estimatedIndexes = []

            $scope.env = BoFeaturesService.getEnv()
            $scope.showButtons = ($scope.env !== 'prod') && ($scope.env.indexOf('-prod') < 0)
            $scope.showDevButtons = $location.host() === 'local.unergie.com'

            $scope.terminationOrigin = ''
            if ($scope.contract.termination_origin && ($scope.contract.status === 14 || $scope.contract.status === 4) && $scope.isCFeatureOn('canViewTerminationOrigin')) {
                $scope.terminationOrigin = $scope.contract.termination_origin === 'PROVIDER' ? ` par ${$scope.providerLabel}` : 'par le client'
            }
            // DATE MODIFICATION (TEST PURPOSE ONLY)
            $scope.showTools = !BoFeaturesService.get('isEnvProd')
            $scope.chgComDatePayload = { commissioning_date: $scope.contract.commissioning_date }
            $scope.chgComDateFields = { commissioning_date: { type: 'date', require: true } }
            $scope.chgDecomDatePayload = { commissioning_date: $scope.contract.decommissioning_date }
            $scope.chgDecomDateFields = { decommissioning_date: { type: 'date', require: true } }

            $scope.changeOfferFields = {
                provider_offer: {
                    label: 'Offre fournisseur',
                    required: true,
                    type: 'select',
                    enum: [],
                },
            }
            $scope.changeOfferPayload = {
                provider_offer: $scope.contract.provider_offer,
            }

            OfferService.selectableOffersPromise.then((mapping) => {
                $scope.changeOfferFields.provider_offer.enum = mapping
            })

            $scope.chgComDate = function () {
                const payload = {
                    commissioning_date: moment($scope.chgComDatePayload.commissioning_date).toISOString(),
                }
                return DataAccess.modifyContract({ id: $scope.contract.id }, payload).$promise.then(() => {
                    AlertManager.success('Date d\'activation modifiée')
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                }).catch(ErrorCatcher)
            }

            $scope.chgDecomDate = function () {
                const payload = {
                    decommissioning_date: moment($scope.chgDecomDatePayload.decommissioning_date).toISOString(),
                }
                return DataAccess.modifyContract({ id: $scope.contract.id }, payload).$promise.then(() => {
                    AlertManager.success('Date de résiliation modifiée')
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                }).catch(ErrorCatcher)
            }

            $scope.changeOffer = () => {
                const oldOffer = $scope.contract.provider_offer
                return ApiUser.modifyContractOffer({ id_contract: $scope.contract.id }, $scope.changeOfferPayload).$promise.then(() => {
                    AlertManager.success('Offre modifiée')
                    const comment = `Offre modifiée : <b>${oldOffer}</b> => <b>${$scope.changeOfferPayload.provider_offer}</b>`
                    AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                }).catch(ErrorCatcher)
            }

            // POST SELF-REPORT
            const reportTemplate = {
                BASE: {
                    date: moment().toDate(),
                    base: undefined,
                    force: false,
                },
                HPHC: {
                    date: moment().toDate(),
                    hp: undefined,
                    hc: undefined,
                    force: false,
                },
            }

            const reportFieldsTemplate = {
                BASE: {
                    date: {
                        label: 'Date',
                        required: true,
                        type: 'date',
                    },
                    base: {
                        label: 'Base',
                        required: true,
                        type: 'text',
                        mask: '9?9?9?9?9?',
                    },
                    force: {
                        label: 'Forcer',
                        require: true,
                        type: 'checkbox',
                    },
                },
                HPHC: {
                    date: {
                        label: 'Date',
                        required: true,
                        type: 'date',
                    },
                    hp: {
                        label: 'Heures pleines',
                        required: true,
                        type: 'text',
                        mask: '9?9?9?9?9?',
                    },
                    hc: {
                        label: 'Heures creuses',
                        required: true,
                        type: 'text',
                        mask: '9?9?9?9?9?',
                    },
                    force: {
                        label: 'Forcer',
                        require: true,
                        type: 'checkbox',
                    },
                },
            }
            $scope.reportPayload = _.clone(reportTemplate[$scope.contract.id_p_calendar])
            $scope.reportFields = _.clone(reportFieldsTemplate[$scope.contract.id_p_calendar])

            $scope.updateReportPayload = function () {
                $scope.reportPayload = _.clone(reportTemplate[$scope.contract.id_p_calendar])
                $scope.reportFields = _.clone(reportFieldsTemplate[$scope.contract.id_p_calendar])
                const mask = '9?9?9?9?9?9?'
                _.forEach(['hc', 'hp', 'base'], (tc) => {
                    if ($scope.reportFields[tc]) {
                        $scope.reportFields[tc].mask = mask
                    }
                    return true
                })
                if ($scope.contract.lastReadings) {
                    return _.forEach($scope.contract.lastReadings, (r) => {
                        $scope.reportPayload[r.temp_class.toLowerCase()] = r.value
                    })
                }
            }

            $scope.selfReport = function () {
                const startDate = moment($scope.reportPayload.date).format('YYYY-MM-DD')
                const payload = _.clone($scope.reportPayload)
                delete payload.date
                delete payload.force
                return ApiUser.selfReport({ id_contract: $scope.contract.id, startDate, force: $scope.reportPayload.force }, payload).$promise
                .then((reportResult) => {
                    if (reportResult && reportResult.status === 'SUCCESS') {
                        AlertManager.success('Relève enregistrée')
                        MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                        return $scope.updateReportPayload()
                    } else if (reportResult && reportResult.status === 'WARNING') {
                        AlertManager.error(`${reportResult.message}, si la relève est confirmée vous pouvez la forcer.`)
                    } else {
                        let message
                        if (reportResult && reportResult.type) {
                            switch (reportResult.type) {
                                case 'LINKY':
                                    message = 'Les auto-relèves ne sont pas acceptées pour les compteurs Linky.'
                                    break
                                case 'ENEDIS':
                                    message = 'Une erreur technique est survenue lors de la transmission à Enedis.'
                                    break
                                case 'CONS_INF_0':
                                    message = 'La relève saisie est inférieure à la dernière relève réelle. Nous vous recontacterons pour vous indiquer la marche à suivre.'
                                    break
                                default:
                                    message = 'Une erreur technique est survenue.'
                            }
                        } else {
                            message = 'Une erreur technique est survenue.'
                        }
                        AlertManager.error(message)
                    }
                }).catch(ErrorCatcher)
            }

            $scope.isMigratedLinky = () => PrmUtilsService.isMigratedLinky($scope.contract.prm)

            const refreshPrmData = {
                next_reading_date: 'la date de prochaine relève',
                metter_kind: 'le type de compteur',
                distributor_it: 'le SI Enedis (DISCO/GINKO)',
                distributor_status: 'l\'état contractuel chez Enedis',
                powered_status: 'l\'état d\'alimentation',
                communicating: 'le caractère communicant',
                telereport: 'présence du boitier téléreport',
                accessible: 'le caractère accessible',
                location: 'la localisation du compteur',
                circuit_breaker_range: 'le calibre du disjonteur',
                circuit_breaker_intensity: `l'intensité du disjoncteur`,
                amperage: 'l\'ampérage du compteur',
                nb_wires: 'le nombre de fils du compteur (MONO/TRIPHASÉ)',
                id_counting_practice: 'Le régime de propriété du compteur',
                metter_number: 'le matricule du compteur',
                service_level: 'le niveau d\'ouverture aux service',
                max_power: 'la puissance souscrite du point',
                id_p_calendar: 'le calendrier fournisseur',
                last_real_reading_date: 'la date de dernière relève réelle',
            }

            const refreshPrmText = Object.keys(refreshPrmData).reduce((acc, k) => `${acc}<li>${refreshPrmData[k]}</li>`, '')

            $scope.refreshPrm = () =>
                ApiUser.refreshPrm({ idContract: $scope.contract.id, idPrm: $scope.contract.id_prm, strict: false }, { prm: 'all' }).$promise.then((updated) => {
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                    AlertManager.success('Mise à jour OK')
                    const comment = '<b>AUTOMATIQUE</b> : PRM rafraichi'
                    return AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher) }).catch(ErrorCatcher)


            $scope.refreshPrmTemplate = {
                expl: {
                    label: `Les informations suivantes vont être mise à jour :<br><ul>${refreshPrmText}</ul>`,
                    type: 'label',
                },
            }

            $scope.getStatusTitle = function (contract) {
                switch (contract.status) {
                    case 0 && moment().isBefore(moment(contract.retraction_end_date)):
                        return 'Nous attendons la fin du délai de rétractation pour transmettre la commande à Enedis, le client peut décider d’y mettre un terme immédiatement.'
                    case 0 && moment(contract.retraction_end_date).isBefore(moment()):
                        return 'La commande doit être traitée par Plüm énergie'
                    case 1:
                        return 'La demande d’activation a été transmise à Enedis, le contrat sera actif d’ici 24h à 48h.'
                    case 2:
                        return 'Le contrat est actif.'
                    case 3:
                        return 'Une ou plusieurs mensualités n’ont pas été payées.'
                    case 4:
                        return 'Le contrat a été résilié.'
                    case 5:
                        return 'Le compteur a été coupé suite à un incident de paiement..'
                    case 6:
                        return 'Notre système n’a pas retrouvé le statut de votre contrat'
                    case 9:
                        return 'L’activation du contrat requiert une action de la part du client.'
                    case 10:
                        return 'Le contrat doit être activé par Plüm énergie'
                    case 80:
                        return 'L’échéancier doit être généré par Plüm énergie'
                    case 81:
                        return 'Une relève du compteur par le client est nécessaire pour l’activation du contrat.'
                    case 82: case 83:
                        return 'La mise en service du compteur électrique nécessite l’intervention d’un technicien Enedis'
                    case 90:
                        return 'La commande a été annulée dans le cadre de la période de rétractation.'
                    case 91:
                        return 'La commande a été annulée'
                    case 92:
                        return 'La commande est bloquée en attente d’une action de la part du client.'
                    default:
                        return 'Le status est inconnu'
                }
            }

            $scope.displayRetractionEndDate = () => $scope.contract.retraction_end_date && moment().subtract(30, 'day').isBefore($scope.contract.retraction_end_date)

            $scope.getOfferTitle = function (contract) {
                switch (_.toUpper(contract.id_p_calendar)) {
                    case 'BASE':
                        return 'L’offre Base est conseillée si vous avez peu d’équipements électriques, ou s’ils sont utilisés principalement en dehors des plages Heures Creuses.'
                    case 'HPHC':
                        return 'L’offre Heures Pleines/Heures Creuses est conseillée si vous avez beaucoup d’équipements électriques, vous paierez moins cher lors de leur utilisation.'
                    default:
                        return 'Le type d’offre est inconnue'
                }
            }

            $scope.getSubscriptionType = function (contract) {
                switch (contract.subscription_type) {
                    case 'CDF':
                    case 'CDF_INTER':
                        return 'Cette souscription à lieu dans le cadre d’un changement de fournisseur d’électricité.'
                    case 'MES':
                    case 'MES_INTER':
                    case 'FIRST_MES':
                        return 'Cette souscription à lieu dans le cadre de l’emménagement du client dans un nouveau logement.'
                    default:
                        return 'Le type de souscription est inconnu'
                }
            }

            $scope.getKrakenMigrationStatusLabel = function (contract) {
                switch (contract.kraken_migration_status) {
                    case 'WAITING_FOR_CFNS':
                        return 'En attente du changement de fournisseur'
                    case 'WAITING_FOR_FINAL_INVOICE':
                        return 'En attente de facturation'
                    case 'FINAL_INVOICE_SENT':
                        return 'Facture de cloture envoyée'
                    case 'FINAL_INVOICE_SENT_TO_KRAKEN':
                        return 'Facture de cloture synchronisée avec kraken'
                    case 'ERROR':
                        return 'Erreur'
                    default:
                        return contract.kraken_migration_status
                }
            }

            $scope.getKrakenMigrationStatusDescription = function (contract) {
                switch (contract.kraken_migration_status) {
                    case 'WAITING_FOR_CFNS':
                        return 'Le changement de fournisseur est en attente de traitement par Enedis'
                    case 'WAITING_FOR_FINAL_INVOICE':
                        return 'Le prm a bien changé de fournisseur, en attente de la facturation Unergie'
                    case 'FINAL_INVOICE_SENT':
                        return 'Le contrat est bien migré dans Kraken et la dernière facture unergie a été envoyée'
                    case 'FINAL_INVOICE_SENT_TO_KRAKEN':
                        return 'Le contrat est bien migré dans Kraken et la dernière facture unergie y est disponible'
                    case 'ERROR':
                        return 'Erreur générique, en parler à la casquette'
                    default:
                        return contract.kraken_migration_status
                }
            }

            $scope.getHeating = function (contract) {
                if (contract.heating === 'electric_heating') {
                    return 'Cette souscription à lieu dans le cadre d’un changement de fournisseur d’électricité.'
                }
                return `Le chauffage principal du client à cette adresse de point de livraison est ${$filter('heating')(contract.heating)}.`
            }

            $scope.getMESTypeLabel = function (contract) {
                const MESTypeLabels = {
                    CDF_INTER: {
                        NORMAL: 'Normal - 10j',
                        EXPRESS: 'Express - 5j',
                    },
                    MES: {
                        NORMAL: 'Normal - Pas d’intervention',
                    },
                    MES_INTER: {
                        NORMAL: 'Normal - 5j',
                        EXPRESS: 'Express - 2j',
                        TODAY: 'Jour même - 1j',
                    },
                    FIRST_MES: {
                        NORMAL: 'Normal - 10j',
                        EXPRESS: 'Express - 5j',
                        TODAY: 'Jour même - 1j',
                    },
                }
                return _.get(MESTypeLabels, [contract.subscription_type, contract.choosen_mes_type], contract.choosen_mes_type)
            }

            $scope.displayActivatedDateField = () => [2, 3, 4, 5, 6, 14, 15].includes($scope.contract.status)

            // BILL SHOCK
            $scope.canBillShock = () => [2, 3, 4, 5, 6, 14, 90].includes($scope.contract.status)

            $scope.loadBillShockForContract = () => ApiUser.billShock({ id_contract: $scope.contract.id })

            $scope.billFilter = function (elem) {
                let html = `<b>Prédiction de régul${$scope.contract.providerOffer.has_pot ? '/cagnotte' : ''} depuis la dernière facture ou mise en service.</b><br>`
                if (!elem.BASE && !elem.HP && !elem.HC) {
                    html += '<span class="fa fa-warning"></span>&nbsp;<b>Pas d\'auto-relève depuis la dernière facture ou mise en service</b>'
                } else {
                    html += `<b>Date départ : </b> ${elem.startDate}<br>`
                    html += `<b>Date fin : </b> ${elem.endDate}<br>`
                    html += `<b>Régule : </b> ${$filter('frAmount')(elem.total)} €<br>`
                    if ($scope.contract.providerOffer.has_pot) {
                        html += `<b>Cagnotte : </b> ${$filter('frAmount')(elem.pot)} €<br>`
                    }
                    _.each(['BASE', 'HP', 'HC'], (tc) => {
                        if (elem[tc]) {
                            const consumed = elem[tc].auto + elem[tc].corrected + elem[tc].real
                            const consumedTitle = `Auto : ${Math.round(elem[tc].auto)} kWh, Estimé Enedis : ${Math.round(elem[tc].corrected)} kWh, Réel : ${Math.round(elem[tc].real)} kWh`
                            html += `<b>${tc} estimé : </b> ${Math.round(elem[tc].estimated)} kWh<br>` +
                                `<span title="${consumedTitle}"><b>${tc} consommé : </b> ${Math.round(consumed)} kWh</span><br>` +
                                `<b>${tc} pertinence : </b> <span${elem[tc].pertinence < 0.7 ? ' style="color: red;"' : ''}>${elem[tc].pertinence * 100} %</span><br>`
                        }
                    })
                }
                return html
            }

            $scope.billPredictionTitle = () => {
                if ($scope.contract.providerOffer.has_pot) {
                    return 'Prédiction de régularisation et/ou cagnotte prochaine facture'
                }
                return 'Prédiction de régularisation de la prochaine facture'
            }

            // ON COMPONENT LOAD
            const fetchEstimatedIndexes = function () {
                $scope.estimatedIndexes = []
                const hasEstimated = ($scope.contract.estimated_v)

                if (($scope.contract.status === 2) && $scope.contract.lastReadings && ($scope.contract.lastReadings.length > 0) && hasEstimated) {
                    const startDate = moment($scope.contract.lastReadings[0].end_date).format('YYYY-MM-DD')
                    const endDate = moment().format('YYYY-MM-DD')

                    let p = Promise.resolve(null)
                    if (startDate !== endDate) { // on ne va pas chercher l'estimé quand la relève date du jour
                        p = ApiCons.monthlyV2({
                            idContract: $scope.contract.id,
                            startDate,
                            endDate,
                            calendar: $scope.contract.id_p_calendar,
                        }).$promise
                    }

                    return p.then((estimated) => {
                        $scope.estimatedIndexes = _.map($scope.contract.lastReadings, (reading) => ({
                            dial: reading.dial,
                            temp_class: reading.temp_class,
                            value: Math.round(estimated ? estimated[reading.temp_class].total : 0) + reading.value,
                        }))
                    })
                    .catch(ErrorCatcher)
                }
            }

            $scope.openPrmAddrModal = () =>
                AddrService.openAddrModal('prm', $scope.contract.prm, (result) => {
                    if (result) {
                        return MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                    }
                })


            $scope.cutChannel = (s) => s.split(':')[1].trim()

            const fetchdeposit = function () {
                if (BoFeaturesService.isFeatureOn('securityDeposit')) {
                    $scope.isDepositNeeded = $scope.contract.isDepositNeeded
                    $scope.isRedFlag = $scope.contract.isRedFlag
                }
            }

            const getBillingModalityLabel = () => {
                if (BoFeaturesService.isFeatureOn('showBillingModality')) {
                    return DataAccess.getModality({ id: $scope.contract.id_billing_modality || 'TWO_MONTHS' }).$promise.then((result) => {
                        $scope.billingModalityLabel = result.label
                    })
                }
            }

            const activate = function () {
                fetchdeposit()
                getBillingModalityLabel()
                return fetchEstimatedIndexes()
            }

            MetaWatcher.watch('DEPOSIT_CHANGED', 'userInfoContractElecInformation', $scope, fetchdeposit)

            activate()



            // TEST BUTTONS
            const templateCDA = {
                analysis_type: '',
                start_date: null,
                end_date: null,
            }
            $scope.CDAfields = {
                analysis_type: {
                    label: 'Analyse à déclencher',
                    placeholder: 'Analyse',
                    type: 'select',
                    enum: [
                        { value: 'CDA_OPTIMIZE_SUBSCRIBED_POWER', label: 'Puissance souscrite' },
                        { value: 'CDA_OPTIMIZE_SUBSCRIBED_PCALENDAR', label: 'Calendrier fournisseur' },
                        { value: 'CDA_STANDBY_CONSUMPTION', label: 'Niveau de veille' },
                        { value: 'CDA_MONTHLY_CONSUMPTION_REPORT', label: 'Mail de suivi conso mensuel' },
                    ],
                },
                start_date: {
                    label: `Date de début de la période d'analyse`,
                    type: 'date',
                },
                end_date: {
                    label: `Date de fin de la période d'analyse`,
                    type: 'date',
                },
            }
            const resetCDAPayload = () => { $scope.CDAPayload = _.clone(templateCDA) }

            resetCDAPayload()

            $scope.CDA = function () {
                const requestBody = {}
                if ($scope.CDAPayload.start_date || $scope.CDAPayload.end_date) {
                    requestBody.timePeriod = {}
                    requestBody.timePeriod.startDate = moment($scope.CDAPayload.start_date).format('YYYY-MM-DD')
                    requestBody.timePeriod.endDate = moment($scope.CDAPayload.end_date).format('YYYY-MM-DD')
                }
                return ApiUser.cdaAnalysis({
                    idContract: $scope.contract.id,
                    analysisType: $scope.CDAPayload.analysis_type,
                }, requestBody).$promise.then((result) => {
                    if (result.diagnosis && result.diagnosis.communication_needed) {
                        AlertManager.success(`Analyse effectuée, communication client nécessaire`)
                    } else {
                        AlertManager.success(`Analyse effectuée, pas de communication client nécessaire`)
                    }
                    resetCDAPayload()
                }).catch((error) => {
                    if (error.data && error.data.status && error.data.status.code === 'CDAS_INELIGIBLE') {
                        AlertManager.error(`Analyse déclenchée, contrat inéligible, code d'inéligibilité : ${error.data.status.detail}`)
                        return error
                    }
                    throw error
                }).catch(ErrorCatcher)
            }

            $scope.buildOpportunityFile = function () {
                return DataAccess.buildOpportunityFile({}, { limit: 10 }).$promise.then(() => {
                    AlertManager.success('Fichier généré')
                }).catch(ErrorCatcher)
            }

            // TEST LOCAL BUTTONS
            $scope.changeStatusTestMode = (status) => {
                const params = { id_contract: $scope.contract.id, status }
                const body = { commissioning_date: moment().toISOString() }

                DataAccess.changeContractStatus(params, body).$promise.then(() => {
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                }).catch(ErrorCatcher)
            }

            $scope.refreshContract = () => {
                MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
            }

            $scope.getRecoveryStatus = function (contract) {
                return contract && contract.overdueRecoveryCampaigns && contract.overdueRecoveryCampaigns.length > 0 ? contract.overdueRecoveryCampaigns[0].partner : ''
            }

            $scope.canSelfReport = () => {
                return _.get($scope.contract, 'prm.service_level', 0) < 1 && [2, 14].includes($scope.contract.status)
            }

            $scope.getSelfReportTitle = () => {
                if (_.get($scope.contract, 'prm.service_level', 0) >= 1) {
                    return 'Le client a un compteur Linky communicant, inutile de faire des auto-relèves'
                }
                if (![2, 14].includes($scope.contract.status)) {
                    return `Le contrat n'est pas actif, passez par le bouton "Activer" pour transmettre une relève`
                }
                return 'Effectuer la relève du compteur'
            }

            $scope.powerInfo = PrmUtilsService.getMinMaxPossiblePower($scope.contract.prm)
            $scope.getExtraPowerInfo = () => {
                return Promise.resolve().then(() => {
                    if (!showDCPowerMax || $scope.contract.prm.service_level < 2) {
                        return null
                    }

                    return ApiCons.dcPowerMax({ idContract: $scope.contract.id }).$promise.then((pmax) => {
                        return (pmax.timePeriod) ? pmax : null
                    })
                })
                .then((pmax) => {
                    return Object.assign({ pmax }, $scope.powerInfo)
                })
            }
            $scope.extraPowerInfoFilter = (powerInfo) => {
                const pmax = powerInfo.pmax
                const mStartDate = pmax && moment(pmax.timePeriod.startDate)
                const mEndDate = pmax && moment(pmax.timePeriod.endDate)
                const isFullDay = pmax && moment(mStartDate).add(1, 'day').isSame(mEndDate) && moment(mStartDate).startOf('day').isSame(mStartDate)

                return [
                    `<b>Disjoncteur</b> : ${powerInfo.circuitBreaker.min}-${powerInfo.circuitBreaker.max} kVA`,
                    `<b>Compteur</b> : max ${powerInfo.metter} kVA`,

                    showDCPowerMax && $scope.contract.prm.meterBreakerLimit && `<b>Puissance souscrite</b> : ${$scope.contract.max_power} kVA`,
                    showDCPowerMax && $scope.contract.prm.meterBreakerLimit && `<b>Seuil tolérance puis. souscrite</b> : ${$scope.contract.prm.meterBreakerLimit.toFixed(2)} kVA`,

                    showDCPowerMax && pmax && `<br><b>Puissance max relevée</b> : ${(pmax.power.value / 1000).toFixed(2)} kVA`,
                    showDCPowerMax && pmax && pmax.peakDate && `atteinte le ${moment(pmax.peakDate).format('DD/MM/YYYY à HH[h]mm')}`,
                    showDCPowerMax && pmax && !pmax.peakDate && isFullDay && `atteinte durant la journée du ${mStartDate.format('DD/MM/YYYY')}`,
                    showDCPowerMax && pmax && !pmax.peakDate && !isFullDay && `atteinte entre le ${mStartDate.format('DD/MM/YYYY à HH[h]mm')}<br>et le ${mEndDate.format('DD/MM/YYYY à HH[h]mm')}`,
                ]
                .filter((x) => x)
                .join('<br>')
            }

            $scope.nextBillableDateDisplay = $scope.contract.next_billable_date ? moment($scope.contract.next_billable_date).add(3, 'day').format('MMMM YYYY') : 'N/A'
            $scope.trueNextBillableDate = $scope.contract.next_billable_date ?
                moment($scope.contract.next_billable_date).format('DD/MM/YYYY') :
                'pas de prochaine date facturable en base de données'

            $scope.getFTAPopoverText = () => {
                return `<b>FTA</b> : ${$scope.contract.prm.routing_tariff}<br>` +
                `<b>Dernière modif. FTA</b> : ${moment($scope.contract.prm.last_routing_tariff_modif_date).format('DD/MM/YYYY')}`
            }

            $scope.getContractConsents = () => {
                return DataAccess.getContractConsents({ id_contract: $scope.contract.id, step: 'RESUME' }).$promise
                .then((consents) => {
                    $scope.dataConsents = consents
                })
                .catch(ErrorCatcher)
            }

            $scope.getContractConsents()

            $scope.openContractConsentsModal = () =>
                ModalService.openModal({ type: 'contractConsentsModal', size: 'lg' }, { contract: $scope.contract, draft: null }, () => $scope.getContractConsents())


            $scope.openEnedisServicesModal = () => {
                ModalService.openModal({ type: 'enedisServicesModal', size: 'lg' }, {
                    idContract: $scope.contract.id,
                })
            }
        },
    })
)
